// extracted by mini-css-extract-plugin
export default {"container":"Services_container__KXwbE","content":"Services_content__oeS68","grid":"Services_grid__lQeGb","button":"Services_button__Bp+V5"};